export enum TableAvailabilityStatus{
  Free = 1,
  InUse = 2
}
